





import { Component, Vue, Watch } from "vue-property-decorator";
import api from "../../network/public_api";
import { AxiosResponse } from "axios";
import { mapGetters } from "vuex";

@Component({
    computed: mapGetters(["isVideoPlaying"])
})
export default class LogoutTimer extends Vue {
    public events: Array<string> = [
        "keypress",
        "scroll",
        "click",
        "mousemove",
        "keydown",
        "fullscreenchange"
    ];
    public logoutTimer: number;
    public timeoutDuration = 15;
    isVideoPlaying!: boolean;
    /**
     *
     * Registers event listeners and start timer.
     *
     */
    mounted(): void {
        this.fetchTimeoutDuration();
        this.registerEvents();
        this.startTimer();
    }

    /**
     *
     * Starts a timeout that is resolved by logout
     *
     */
    startTimer(): void {
        this.logoutTimer = setTimeout(
            this.logout,
            (this.timeoutDuration * 60 * 1000)
        ); //? Convert minutes to millisecond
    }

    /**
     *
     * Dispatch logout action and redirect to /login
     *
     */
    logout(): void {
        this.$store.dispatch("logout");
    }

    /**
     *
     * Clears logoutTimer and invokes a new one.
     *
     */
    resetTimer(): void {
        clearTimeout(this.logoutTimer);

        this.startTimer();
    }

    /**
     *
     * Timeout duration system setting request.
     *
     */
    fetchTimeoutDuration(): void {
        api.get("/system_settings/timeout_duration")
            .then(
                (res: AxiosResponse) =>
                    (this.timeoutDuration = parseInt(res.data.value))
            )
            .catch(err => console.error(err));
    }

    @Watch("isVideoPlaying")
    disableTimer(isVideoPlaying: boolean) {
        if (this.$route.name === "Training Room") {
            if (isVideoPlaying) {
                this.removeEvents();
                clearTimeout(this.logoutTimer);
            } else {
                this.registerEvents();
                this.startTimer();
            }
        }
    }

    registerEvents(): void  {
        this.events.forEach(event =>
            window.addEventListener(event, this.resetTimer)
        );
    }

    removeEvents(): void {
        this.events.forEach(event =>
            window.removeEventListener(event, this.resetTimer)
        );
    }
    
    /**
     *
     * Remove event listeners.
     */
    beforeDestroy(): void {
        this.removeEvents();
        clearTimeout(this.logoutTimer);
    }
}
